import angular from 'angular';
import './call-frames-branded-logo.scss';
import template from './call-frames-branded-logo.html';
import { selectInstitution } from '../../../../store/features/system/selectors';
class CallFramesBrandedLogoController {
    constructor($ngRedux) {
        $ngRedux.connect((state) => ({
            src: selectInstitution(state)?.logoHorizontal,
        }))(this);
    }
    static { this.$inject = ['$ngRedux']; }
}
const callFramesBrandedLogoComponent = {
    template,
    controller: CallFramesBrandedLogoController,
};
export default angular
    .module('doxy.videoChat.callFrames.callFramesBrandedLogo', [])
    .component('callFramesBrandedLogo', callFramesBrandedLogoComponent).name;
